<script setup>
import { swalError, swalSuccess } from '@/helper';
import { update_reward_action } from '@/services/reward_actions';
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
  reward_action:{
    type: Object
  }
})
const intValue = ref()
onMounted(()=>{
  intValue.value = props.reward_action.attributes.point_value
})

const isChange = computed(()=>{
  return intValue.value !== props.reward_action.attributes.point_value ? true : false
})

function resetValue(){
  props.reward_action.attributes.point_value = intValue.value
}

async function updateValue(){
  const { title, description, point_value } = props.reward_action.attributes
  let params = {title, description, point_value}
  let response = await update_reward_action(props.reward_action.id, params)
  if (response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Update successfully')
  intValue.value = props.reward_action.attributes.point_value
}

</script>

<template>
  <div class="col-md-12">
    <div class="col-md-6 row mb-3">
      <label :for="reward_action.attributes.tag" class="col-sm-4 col-form-label">
        {{ reward_action.attributes.title }}
      </label>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-8">
            <input type="number" class="form-control text-end" 
              :id="reward_action.attributes.tag"
              v-model="reward_action.attributes.point_value"
            >
          </div>
          <div class="col-md-4 row justify-content-between align-items-center"
            v-if="isChange"
          >
            <button @click="updateValue"
              class="btn icon-btn btn-light-success"
            >
              <vue-feather type="check"></vue-feather>
            </button>
            <button @click="resetValue"
              class="btn icon-btn btn-light-danger"
            >
              <vue-feather type="x"></vue-feather>
            </button>
          </div>
        </div>
        <div class="form-text">
          {{ reward_action.attributes.description }}
        </div>
      </div>
      
    </div>
  </div>
</template>